import { useCallback, useEffect } from 'react';

import { toast } from 'sonner';
import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import Honeybadger from '@honeybadger-io/js';

import { ERROR_TITLES } from '../constants';
import { updateTask as apiUpdateTask } from '../services/taskService';
import useBoard from './useBoard';

const useDragAndDrop = () => {
  const { statuses, tasks, updateTask } = useBoard();

  const handleTaskMove = useCallback(
    async (taskId, destinationStatusId) => {
      const findTask = (taskId) => tasks.find((task) => task.id === taskId);
      const findStatus = (statusId) => statuses.find((status) => status.id === statusId);

      const task = findTask(taskId);
      const newStatus = findStatus(destinationStatusId);
      const taskData = { taskStatusId: destinationStatusId };

      try {
        await apiUpdateTask({ taskData, taskId });
        updateTask({ ...task, taskStatus: newStatus });
      } catch (error) {
        toast.error(ERROR_TITLES.task.update, { description: error.message });
        Honeybadger.notify(error);
      }
    },
    [tasks, statuses, updateTask]
  );

  useEffect(() => {
    return monitorForElements({
      onDrop: async ({ source, location }) => {
        const destination = location.current.dropTargets[0];

        if (!destination) return;

        const taskId = source.data.id;
        const sourceStatusId = source.data.statusId;
        const destinationStatusId = destination.data.id;

        if (sourceStatusId === destinationStatusId) return;

        handleTaskMove(taskId, destinationStatusId);
      },
    });
  }, [handleTaskMove]);
};

export default useDragAndDrop;
